import { useAuthStore } from '@/stores/useAuthStore'

// ���岻��Ҫ��¼���ɷ��ʵ�ҳ�������
const publicRoutes = ['login', 'home', 'home-usage', 'home-services']

export function setupRouterGuards(router) {
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()

    // 1. ���ȥ��¼ҳ���ѵ�¼ֱ��ȥ����̨��δ��¼����
    if (to.name === 'login') {
      const ok = await authStore.ensureSession()
      if (ok) {
        next({ name: 'upload' })
      } else {
        next()
      }
      return
    }

    // 2. ���ȥ������ҳ��˵��ҳ�ȹ���ҳ�棬ֱ�ӷ��� (����ǿ��Ҫ�� Session)
    if (publicRoutes.includes(to.name)) {
      next()
      return
    }

    // 3. ��������ҳ�� (������̨ҳ��)��ִ��ԭ�е�ǿ��У���߼�
    if (authStore.userInfo) {
      next()
      return
    }

    const ok = await authStore.ensureSession()
    if (!ok) {
      // У��ʧ�ܣ����ز���ص�¼ҳ�����ϱ�����ȥ��·���������¼������
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }

    next()
  })
}